export const bookWithMeShareButtonLabel = "I8_6gc";
export const bookWithMeBookATimeWithMeText = "pxxGyc";
export const bookWithMePersonalBooking = "qJ4joc";
export const bookWithMeSaveBookingToSignatureSuccess = "t8ARO";
export const bookWithMeCopyLinkText = "NQCc6b";
export const bookWithMeShareViaEmailText = "ZWZPJ";
export const bookWithMeAddToEmailSignature = "rqal1c";
export const bookwithmeDisabledShareButtonToolTipMessage = "_TwKcd";
export const bookWithMeAddToSignatureLabel = "HOyxTc";
export const bookWithMeSaveSignatureLabel = "GqTOk";
export const bookwithme_options_dismiss_header = "nLnilb";
export const bookWithMeDiscardBookingToSignatureSuccess = "uo1rV";
export const bookWithMeNoPublicMeetingsToolTip = "uzoP1b";
export default {bookWithMeShareButtonLabel,bookWithMeBookATimeWithMeText,bookWithMePersonalBooking,bookWithMeSaveBookingToSignatureSuccess,bookWithMeCopyLinkText,bookWithMeShareViaEmailText,bookWithMeAddToEmailSignature,bookwithmeDisabledShareButtonToolTipMessage,bookWithMeAddToSignatureLabel,bookWithMeSaveSignatureLabel,bookwithme_options_dismiss_header,bookWithMeDiscardBookingToSignatureSuccess,bookWithMeNoPublicMeetingsToolTip};